export let StatusCode = /*#__PURE__*/function (StatusCode) {
  StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
  StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
  StatusCode[StatusCode["GONE"] = 410] = "GONE";
  StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
  return StatusCode;
}({});
export function isAuthError(error) {
  return isErrorStatusCode(StatusCode.UNAUTHORIZED, error) || isErrorStatusCode(StatusCode.FORBIDDEN, error);
}
export function isErrorStatusCode(statusCode, error) {
  var _error$message;
  if (!error) {
    return false;
  }
  if (error['status'] === statusCode || error['statusCode'] === statusCode) {
    return true;
  }
  const reg = new RegExp(`status (code)?.*(${statusCode})`);
  return !!(error !== null && error !== void 0 && (_error$message = error.message) !== null && _error$message !== void 0 && _error$message.match(reg));
}